"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Hero() {
    return react_1.default.createElement("div", { style: { backgroundImage: "url('https://cdn.eyecons.com/front-end/img/eyecons-hero-e.png')" }, className: "storybook-subscriptions-hero" },
        react_1.default.createElement(storybook_1.Layouts.Container, null,
            react_1.default.createElement("div", { className: 'space-y-8 md:space-y-10 pt-8 md:pt-20' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h1', className: 'storybook-subscriptions-hero-title text-3xl sm:text-4xl lg:text-5xl' }, "De kracht van live en on demand sport"),
                react_1.default.createElement("div", { className: 'storybook-subscriptions-hero-description text-lg lg:text-xl' }, "Alle tools die je nodig hebt om je fans te bereiken en je content te monetizen"),
                react_1.default.createElement(storybook_1.Subscriptions.Features, null))));
}
exports.default = Hero;
